import { render, staticRenderFns } from "./nav_footer.vue?vue&type=template&id=96e5c584&scoped=true&lang=html&"
import script from "./nav_footer.vue?vue&type=script&lang=js&"
export * from "./nav_footer.vue?vue&type=script&lang=js&"
import style0 from "./nav_footer.vue?vue&type=style&index=0&id=96e5c584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e5c584",
  null
  
)

export default component.exports